<template>
    <div class="container">
        <div :class="{'search': search}">
            <router-link @click.native="$emit('close')" :to="{name: 'admin.users.edit', params: {id: user.id}}">
                {{user.name.toUpperCase() + ' ' +
                user.firstname.charAt(0).toUpperCase() + user.firstname.slice(1)}}
            </router-link>
            <small v-if="!list">{{user.is_dancer ? 'danseur' : ''}}</small>
        </div>
        <div class="desktop" v-if="search">
            <a v-if="user.legal_resps.length === 0" :href="'mailto:' + user.email">{{user.email}}</a>
            <a v-else target="_blank" :href="'mailto:' + user.legal_resps[0].email">{{user.legal_resps[0].email}}</a>
        </div>
        <div class="desktop" v-if="search">
            <a v-if="user.legal_resps.length === 0"
               :href="'tel:' + user.tel">{{$formatTel(user.tel)}}</a>
            <a v-else
               :href="'tel:' + user.legal_resps[0].tel">{{$formatTel(user.legal_resps[0].tel)}}</a>
        </div>

        <div>
            <pill v-if="!search" :bg-color="certificateColor">{{isMobile ? 'CM' : 'Certificat médical'}}</pill>
            <pill style="margin-left: 8px;" v-else-if="user.is_dancer" :bg-color="certificateColor">CM</pill>
        </div>
        <div>
            <span class="action-column">
                <pill @click.native="openDropDown(paymentId)" style="cursor: pointer;" :bg-color="paymentColor">{{isMobile ? 'P' : 'Paiement'}}</pill>
            <div v-click-outside="close" style="cursor: pointer;" class="actions"
                 :id="'pill-'+paymentId">
                <div>
                    <pill style="cursor: pointer;" bg-color="pill-danger"
                          @click.native="changeStatus(paymentId, false)">À payer
                    </pill>
                    <pill style="cursor: pointer;" bg-color="pill-success"
                          @click.native="changeStatus(paymentId, true)">Réceptionné
                    </pill>
                </div>
            </div>
            </span>
        </div>
        <div>
            <uni-cta-link @click.native="$emit('close')"
                          :to="{name: 'admin.families.edit', params: {id: user.family_id}}"
                          class="uni-cta-link--secondary uni-cta-link--extra-small">{{isMobile ? 'Famille' : 'Voir la '
                +
                'famille'}}
            </uni-cta-link>
        </div>
    </div>
</template>

<script>
    import Pill from "../a-elements/pill";
    import UniButton from "../a-elements/UniButton";
    import UniCtaLink from "../a-elements/UniCtaLink";
    import ClickOutside from 'vue-click-outside';
    import {mapGetters} from "vuex";

    export default {
        name: "userInline",
        components: {UniCtaLink, UniButton, Pill},
        props: {
            user: Object,
            list: {
                type: Boolean,
                default: false
            },
            search: {
                type: Boolean,
                default: false
            },
            quarter: {
                type: Number,
            }
        },
        directives: {
            ClickOutside
        },
        data() {
            return {
                isMobile: true,
                paymentId: 0
            }
        },

        computed: {
            certificateColor() {
                if (this.user.medical_certificate) {
                    if (this.user.medical_certificate.year) {
                        return "pill-success"
                    } else {
                        return "pill-warning"
                    }
                } else {
                    return "pill-danger"
                }
            },
            paymentColor() {
                if (this.user.payments.length === 0) {
                    return "pill-danger"
                } else {
                    if (this.user.payments.length === 1) {
                        this.paymentId = this.user.payments[0].id
                        return this.whichPaymentColor(this.user.payments[0].status)

                    } else {
                        if (this.quarter) {
                            this.paymentId = this.user.payments[this.quarter - 1].id
                            return this.whichPaymentColor(this.user.payments[this.quarter - 1].status)

                        } else {
                            this.paymentId = this.user.payments[this.$currentTrimestre() - 1].id
                            return this.whichPaymentColor(this.user.payments[this.$currentTrimestre() - 1].status)

                        }
                    }
                }
            },
            ...mapGetters({currentFamily: 'currentFamily'})
        },
        methods: {
            displayTel(bool) {
                if (this.user.legal_resps.length > 0) {
                    if (bool) {
                        return this.$formatTel(this.user.legal_resps[0].tel)
                    } else {
                        return this.user.legal_resps[0].tel
                    }
                } else {
                    if (bool) {
                        return this.$formatTel(this.user.tel)
                    } else {
                        return this.user.tel
                    }
                }
            },
            whichPaymentColor(status) {
                if (status) {
                    return "pill-success"
                } else if (status === null) {
                    return "pill-warning"
                } else {
                    return "pill-danger"
                }
            },
            openDropDown(id) {
                if (this.currentFamily.isPayment) {
                    let opened = document.querySelector('.actions.open')
                    if (opened) {
                        opened.classList.remove("open")
                        window.setTimeout(() => {
                            opened.style.display = "none"
                        }, 300)
                    }

                    let div = document.querySelector('#pill-' + id)
                    div.style.display = "block"
                    window.setTimeout(() => {
                        div.classList.add("open")
                    }, 100)
                }
            },
            close() {
                let opened = document.querySelector('.actions.open')
                if (opened) {
                    opened.classList.remove("open")
                    window.setTimeout(() => {
                        opened.style.display = "none"
                    }, 300)
                }
            },
            changeStatus(id, status) {

                this.$adminChangePaymentStatus(id, status)
                    .then(data => {
                        this.user.payments = data.payments
                    })
            }
        },

        mounted() {
            const width = window.innerWidth || document.documentElement.clientWidth ||
                document.body.clientWidth
            this.isMobile = width < 768
        }


    }
</script>

<style scoped lang="scss">

    .desktop {
        display: none;
    }

    .container {
        width: 100%;
        border-radius: var(--radius-big);
        background: var(--color-grey-light-2);
        color: var(--color-black);
        padding: 8px 16px;
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        align-items: center;
        gap: .5rem;

        > div:first-child {

            a {
                white-space: initial;
            }

            &.search {
                width: 120px;
            }
        }

        > div:nth-child(2) {
            justify-self: center;
        }

        > div:nth-child(3) {
            justify-self: center;
        }

        a {
            margin: 0;
        }

        margin-bottom: 16px;

    }

    .actions {
        display: none;
    }

    .action-column {
        position: relative;
    }


    @include screen-m {
        .desktop {
            display: block;
        }

        .actions {
            top: -8px;
            left: 100px;
            position: absolute;
            padding: 8px 16px;
            background: var(--color-white);
            box-shadow: var(--shadow-s);
            border-radius: var(--radius-big);
            width: 300px;
            display: none;
            opacity: 0;
            transform: translateX(-15px);
            transition: all .3s ease-in-out;
            z-index: 10;

            &.open {
                opacity: 1;
                transform: translateX(0);
            }

            > div {
                display: grid;
                grid-template-columns: 1fr 1fr 1fr;
                gap: 8px;
            }
        }
    }

    @include screen-l {
        .container {
            > div:first-child {
            }

            > div:nth-child(2) {
                justify-self: center;
            }

            > div:nth-child(3) {
                width: 80px;
                justify-self: center;
            }
        }
    }

</style>
